/**
 * @file 快速开始 api
 * @author FengGuang(fengguang01@baidu.com)
 */
import request from 'superagent';
import baseRequest from '../baseApi';
import baseRequestText from '../baseApiText';

interface ISubmitFeedbackParams {
    question: string;
    screenshot: string;
    url: string;
}

// 提交反馈
export const fetchSubmitFeedback = (params: ISubmitFeedbackParams): Promise<request.Response> =>
    baseRequest(
        request.post('/platform/usercase/send')
            .query({type: 9})
            .send(params)
    );

// 获取快速安装
export const fetchGetQuickInstall = (): Promise<request.Response> =>
    baseRequest(
        request.get('/platform/page/data')
            .query({requestUrl: '/install/quick2'})
            .query(window.location.search.slice(1))
    );

// 获取旧文档
export const fetchGetOldDocInstall = (): Promise<request.Response> =>
    baseRequest(
        request.get('/platform/page/data')
            .query({requestUrl: '/install/old'})
            .query(window.location.search.slice(1))
    );

// 获取快速安装详情
export const fetchGetQuickInstallDetail = (url: string): Promise<request.Response> =>
    baseRequestText(
        request.get(url)
            .query({raw: 'true'})
    );

// 获取旧文档详情
export const fetchGetOldDocDetail = (): Promise<request.Response> =>
    baseRequest(
        request.get('/platform/page/data')
            .query({requestUrl: '/install/old'})
            .query(window.location.search.slice(1))
    );

